<template>
    <div class="lp-categories">
        <div class="row introduction">
            <div class="col-12">
                <design2021-apprentice-display-html-component :html-content="lpSettings.description">
                </design2021-apprentice-display-html-component>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-md-6 col-lg-6 col-xl-3 d-flex flex-column" v-for="lpCategory of lpCategories">
                <design-2021-learning-path-category-overview-card-component :lp-category-in="lpCategory" :lp-deadline-id-in="lpDeadlineIdIn">
                </design-2021-learning-path-category-overview-card-component>
            </div>
        </div>
    </div>
</template>

<script>
import Design2021ApprenticeDisplayHtmlComponent from "../../common/design-2021-apprentice-display-html-component.vue";
export default {
    name: "design-2021-learning-path-category-overview-component",
    components: {Design2021ApprenticeDisplayHtmlComponent},
    props: ['lpCategoriesIn','lpDeadlineIdIn', 'lpSettings'],
    data() {
        return {
            lpCategories: this.lpCategoriesIn,
            source:  {
                type: 'video/youtube',
                src: 'https://www.youtube.com/embed/_uQeE_FMstM'
            },
        }
    }
}
</script>

<style scoped lang="scss">
    .introduction {
        margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
    }

    .lp-category-info {
        font-size: $base-font-size;
        line-height: 1.5;
    }
</style>
